module.exports = __webpack_public_path__ + "static/media/Montserrat-LightItalic.2e1e2b59.eot";